import { Component, JSXElement } from "solid-js";

export interface LayoutProps {
  header?: JSXElement;
  children: JSXElement;
  footer?: JSXElement;
}

export const Layout: Component<LayoutProps> = (props) => {
  return (
    <div class="flex min-h-screen flex-col">
      <header class="flex-auto shrink-0 grow-0">{props.header}</header>
      <main class="flex flex-auto shrink-0 items-center justify-center">
        <div>{props.children}</div>
      </main>
      <footer class="flex-auto shrink-0 grow-0">{props.footer}</footer>
    </div>
  );
};
